import { useAtom } from "jotai";
import React, { useEffect, useRef } from "react";
import { usePresenceUpdater } from "./usePresenceUpdater";
import { currentUserAtom } from "../jotai/atoms";
import { useUserInfos } from "../liveblocks/maps";
import { useOnlinesSetup } from "../liveblocks/presences";
import { useStampModeSetup } from "./useStamp";
import { User } from "../types";
import { usePreview } from "../ui/selection";
import { useCursorUpdater } from "../ui/cursor/useCursorUpdater";

function Presence() {
  usePresenceUpdater();
  useOnlinesSetup();
  useStampModeSetup();
  usePreview();
  useCursorUpdater();

  const [currentUser, setCurrentUser] = useAtom(currentUserAtom);
  const [, userInfos] = useUserInfos();
  const userInfoClient = currentUser ? userInfos?.get(currentUser.id) : null;
  const infoInited = useRef(false);

  useEffect(() => {
    if (!userInfoClient || !currentUser) return;

    /**
     * user could have different setting (name, color) in each space, and we
     * call these setting "user info".
     *
     * if the user is entering the space for the first time, we would initialize user
     * info with some default value stored in the db.
     *
     * if user has previosuly entered the space before, we would re-use the
     * previously setting (name & color)
     */
    function initUserInfo(field: keyof User) {
      if (!userInfoClient || !currentUser) return;

      const remote = userInfoClient.get(field);
      const local = currentUser[field];

      if (remote) {
        if (local !== remote) {
          setCurrentUser({ ...currentUser, [field]: remote });
        }
      } else {
        userInfoClient.set(field, local);
      }
    }

    initUserInfo("id");
    initUserInfo("name");
    initUserInfo("color");

    infoInited.current = true;
  }, [currentUser, setCurrentUser, userInfoClient]);

  return <></>;
}

export default Presence;
